import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from 'react-router-dom';
import { translate } from '@haldor/ui';
import swal from "sweetalert2";
import api from 'lib/api';
import { setPageTitle, setPageActions } from "actions/header";
import { getCourse, setActiveCourse } from "actions/courses";
import { getMatrix } from "actions/matrix";
import { newGuid } from "helpers/guid";
import Modal from "containers/Modals/Modal";
import CourseForm from "containers/Forms/CourseForm";
import MatrixDisplayBlock from "../Matrix/MatrixDisplay/MatrixDisplayBlock";
import PostContent from "components/Presentation/PostContent";
import SelectedCoreContent from "containers/CoreContent/Selected";
import User from '_class/User';
import { Expandable, Spinner } from "UI";
import { Block, Button, Icon } from "@haldor/ui";

var SingleCourse = /*#__PURE__*/function (_Component) {
  _inherits(SingleCourse, _Component);

  var _super = _createSuper(SingleCourse);

  function SingleCourse(props) {
    var _this;

    _classCallCheck(this, SingleCourse);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.setActiveCourse();
    });

    _defineProperty(_assertThisInitialized(_this), "removeCourse", function (event) {
      event.preventDefault();
      swal.fire({
        title: _this.props.translate("are-you-sure"),
        text: _this.props.translate("remove-course-prompt-text"),
        showCancelButton: true,
        cancelButtonText: _this.props.translate("Cancel"),
        confirmButtonText: _this.props.translate("Remove")
      }).then(function (result) {
        if (result.value != null) {
          var _this$props$match;

          var courseId = ((_this$props$match = _this.props.match) === null || _this$props$match === void 0 ? void 0 : _this$props$match.params.courseId) || _this.props.courseId;
          api["delete"]('courses/' + courseId).then(function (response) {
            if (response.status != 200) {
              return false;
            }

            _this.props.history.push('/courses');
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modalIsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function (reload, skipPrompt) {
      if (skipPrompt) {
        if (reload) {
          var _this$props$match2;

          _this.setState({
            loading: true
          });

          var courseId = ((_this$props$match2 = _this.props.match) === null || _this$props$match2 === void 0 ? void 0 : _this$props$match2.params.courseId) || _this.props.courseId;

          _this.props.getCourse(courseId).then(function () {
            var details = _this.props.course.details;
            var _ParagraphSet = [];

            if (details[0] != null) {
              if (details[0].matrix != null) {
                if (details[0].matrix._ParagraphSet != null) {
                  _ParagraphSet = details[0].matrix._ParagraphSet;
                }
              }
            }

            _this.setState({
              _ParagraphSet: _ParagraphSet,
              modalIsOpen: false,
              loading: false
            });
          });
        } else {
          _this.setState({
            modalIsOpen: false
          });
        }
      } else {
        if (reload) {
          var _this$props$match3;

          _this.setState({
            loading: true
          });

          var _courseId = ((_this$props$match3 = _this.props.match) === null || _this$props$match3 === void 0 ? void 0 : _this$props$match3.params.courseId) || _this.props.courseId;

          _this.props.getCourse(_courseId, function (data) {
            var details = data.details;
            var _ParagraphSet = [];

            if (details[0] != null) {
              if (details[0].matrix != null) {
                if (details[0].matrix._ParagraphSet != null) {
                  _ParagraphSet = details[0].matrix._ParagraphSet;
                }
              }
            }

            _this.setState({
              _ParagraphSet: _ParagraphSet,
              loading: false,
              modalIsOpen: false
            });
          });
        } else {
          _this.setState({
            modalIsOpen: false
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "CreateButton", function (enabled) {
      return /*#__PURE__*/React.createElement(Button, {
        disabled: !enabled,
        type: "secondary",
        onClick: _this.openModal
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      }), " ", _this.props.translate("edit-course"));
    });

    _this.state = {
      loading: false,
      matrixList: [],
      modalIsOpen: false,
      _ParagraphSet: []
    };
    return _this;
  }

  _createClass(SingleCourse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$match4,
          _this2 = this;

      this.setState({
        loading: true
      });
      var courseId = ((_this$props$match4 = this.props.match) === null || _this$props$match4 === void 0 ? void 0 : _this$props$match4.params.courseId) || this.props.courseId;
      this.props.getCourse(courseId).then(function () {
        var course = _this2.props.course;
        var details = _this2.props.course.details;
        var _ParagraphSet = [];

        _this2.props.setPageTitle(course.title);

        if (details[0] != null) {
          if (details[0].matrix != null) {
            if (details[0].matrix._ParagraphSet != null) {
              _ParagraphSet = details[0].matrix._ParagraphSet;
            }
          }
        }

        _this2.setState({
          _ParagraphSet: _ParagraphSet,
          loading: false
        });
      });
    }
  }, {
    key: "renderMatrix",
    value: function renderMatrix() {
      var _this3 = this;

      if (this.props.course.details[0] != null) {
        if (this.props.course.details[0].matrix != null) {
          var details = this.props.course.details;

          if (!details[0].matrix.disableNotAchieved) {
            if (details[0].matrix._ParagraphSet != null) {
              details[0].matrix._ParagraphSet.forEach(function (paragraph) {
                paragraph.rows.forEach(function (row) {
                  var searchNotAchieved = row.cells.find(function (co) {
                    return co.gradeF == true;
                  });

                  if (searchNotAchieved == null) {
                    var id = newGuid();
                    var stepId = newGuid();
                    var gradeF = {
                      id: stepId,
                      text: _this3.props.translate("not-achieved"),
                      gradeF: true
                    };
                    row.cells.unshift(gradeF);
                  }
                });
              });
            }
          }

          return /*#__PURE__*/React.createElement(Expandable, {
            key: this.props.course.details[0].matrix.id,
            title: this.props.course.details[0].matrix.title
          }, this.props.course.details[0].matrix._ParagraphSet != null ? this.props.course.details[0].matrix._ParagraphSet.map(function (paragraph) {
            return /*#__PURE__*/React.createElement("div", {
              style: {
                marginTop: "1rem"
              },
              key: "r-paragraph-".concat(paragraph.paragraphNr)
            }, paragraph.title != null && paragraph.title != "" ? /*#__PURE__*/React.createElement("div", {
              className: "single-section matrix-paragraph-title",
              style: {
                paddingTop: "0px",
                marginBottom: "5px"
              }
            }, /*#__PURE__*/React.createElement("strong", null, paragraph.title)) : null, paragraph.subtitle != null && paragraph.subtitle != "" ? /*#__PURE__*/React.createElement("div", {
              className: "single-section matrix-paragraph-subtitle",
              style: {
                paddingTop: "0px",
                marginBottom: "5px"
              }
            }, paragraph.subtitle) : null, paragraph.rows.map(function (block) {
              return /*#__PURE__*/React.createElement(MatrixDisplayBlock, {
                key: block.id,
                block: block,
                associatedBlock: {
                  clarifications: []
                }
              });
            }));
          }) : null);
        }
      }
    }
  }, {
    key: "renderCourse",
    value: function renderCourse() {
      var _this4 = this;

      var _this$props = this.props,
          course = _this$props.course,
          translate = _this$props.translate;
      var user = new User(this.props.currentUser);

      if (course != null) {
        var _course$details$, _course$details$2;

        var coreContent = (_course$details$ = course.details[0]) === null || _course$details$ === void 0 ? void 0 : _course$details$.coreContent;
        var coreContents = [{
          courseTitle: null,
          courseId: course.id,
          coreContents: (_course$details$2 = course.details[0]) === null || _course$details$2 === void 0 ? void 0 : _course$details$2.coreContent
        }];
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task",
          style: {
            margin: '2rem'
          }
        }, /*#__PURE__*/React.createElement(Modal, {
          isOpen: this.state.modalIsOpen,
          onClose: function onClose() {
            return _this4.closeModal(false, false);
          },
          title: translate("edit-course")
        }, /*#__PURE__*/React.createElement(CourseForm, {
          onClose: this.closeModal,
          editView: true
        })), /*#__PURE__*/React.createElement("div", {
          className: "single-section form left-side",
          style: {
            paddingTop: "0"
          }
        }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
          className: "title"
        }, translate("description")), /*#__PURE__*/React.createElement(PostContent, null, course.description), course.details[0] != null && course.details[0].purpose != null ? /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: "1rem"
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "title"
        }, this.props.translate("purpose")), /*#__PURE__*/React.createElement(PostContent, null, course.details[0].purpose)) : null)), /*#__PURE__*/React.createElement("div", {
          className: "single-actions right-side"
        }, /*#__PURE__*/React.createElement("div", {
          className: "action-section"
        }, /*#__PURE__*/React.createElement("h3", null, this.props.translate("tools")), this.CreateButton(user.isUserCurriculumAdmin() || (course.tenantId == null || course.tenantId == this.props.tenant.id) && course.type != "PREDEFINED_COURSE"), /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: 5
          }
        }, /*#__PURE__*/React.createElement(Button, {
          disabled: !(user.isUserCurriculumAdmin() || (course.tenantId == null || course.tenantId == this.props.tenant.id) && course.type != "PREDEFINED_COURSE" && course.isUsed == false),
          type: "secondary",
          onClick: this.removeCourse
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Bin"
        }), " ", this.props.translate('remove-course'))))), /*#__PURE__*/React.createElement("div", {
          style: {
            clear: "both"
          }
        }), course.details[0] != null && course.details[0].coreContent != null ? /*#__PURE__*/React.createElement("div", {
          className: "single-task-description",
          style: {
            marginTop: "2.5em"
          }
        }, /*#__PURE__*/React.createElement(SelectedCoreContent, {
          coreContents: coreContents
        })) : null, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }) : /*#__PURE__*/React.createElement("div", {
          className: "course-matrix-list",
          style: {
            marginTop: "3em"
          }
        }, this.renderMatrix()));
      }

      return /*#__PURE__*/React.createElement("div", null);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.course == null) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      return /*#__PURE__*/React.createElement("div", null, this.renderCourse());
    }
  }]);

  return SingleCourse;
}(Component);

function mapStateToProps(state) {
  return {
    course: state.Courses.course,
    matrix: state.Matrix.matrix,
    tenant: state.user.tenant,
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations)
  };
}

export default withRouter(connect(mapStateToProps, {
  setActiveCourse: setActiveCourse,
  getMatrix: getMatrix,
  getCourse: getCourse,
  setPageTitle: setPageTitle,
  setPageActions: setPageActions
})(SingleCourse));